export const FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE =
  'fetch_and_sync_achievement_updates';
export const GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE = 'get_achievements_stats';
export const GET_LEAGUE_POINTS_REWARD_LEVELS_MESSAGE_TYPE =
  'get_league_points_reward_levels';
export const GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE = 'get_recent_achievements';
export const GET_USER_ACHIEVEMENTS_MESSAGE_TYPE = 'get_user_achievements';
export const GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE =
  'get_user_league_points_rewards_balance';
